function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );

    return JSON.parse(jsonPayload);
}

const promiseWithTimeout = (promise) => {
    let timeoutId;
    const timeoutPromise = new Promise((_, reject) => {
        timeoutId = setTimeout(() => {
            reject(new Error('timeout'));
        }, 10000);
    });
    return {
        promiseOrTimeout: Promise.race([promise, timeoutPromise]),
        timeoutId
    };
};

export default (() => {
    const self = {
        getUsername: () => parseJwt(self.getToken()).unique_name,
        setToken: (token) => localStorage.setItem('auth_token', token),
        getToken: () => localStorage.getItem('auth_token'),
        isTokenOk: () => {
            var token = self.getToken();
            if (!token) {
                return false;
            }
            var exp = parseJwt(token).exp;
            if (Date.now() >= exp * 1000) {
                return false;
            }
            return true;
        },
        loginWithUsernameAndPassword: async (username, password) => {
            let { promiseOrTimeout, timeoutId } = promiseWithTimeout(
                fetch(process.env.REACT_APP_API_URL_BASE + 'login', {
                    method: 'POST',
                    body: JSON.stringify({
                        Username: username,
                        Password: password
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            );
            return promiseOrTimeout
                .then(
                    (r) => {
                        if (r.ok) {
                            return r
                                .json()
                                .then((json) => {
                                    self.setToken(json.token);
                                })
                                .then(() => 'OK');
                        } else if (r.status === 500) {
                            return 'Palvelinvirhe. Yritä myöhemmin uudelleen.';
                        } else if (r.status === 403) {
                            return 'Käyttäjätunnus tai salasana on väärin.';
                        } else return 'Kirjautuminen epäonnistui.';
                    },
                    (r) => 'Palvelimeen ei saada yhteyttä. Tarkista internetyhteytesi tai yritä myöhemmin uudelleen.'
                )
                .finally(() => clearTimeout(timeoutId));
        },
        logout: () => localStorage.removeItem('auth_token'),
        AddPassword: async (username, password, securitystamp) => {
            let { promiseOrTimeout, timeoutId } = promiseWithTimeout(
                fetch(process.env.REACT_APP_API_URL_BASE + 'login/addPassword', {
                    method: 'POST',
                    body: JSON.stringify({
                        Username: username,
                        Password: password,
                        Securitystamp: securitystamp
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            );
            return promiseOrTimeout
                .then(
                    (r) => {
                        if (r.ok) {
                            return r
                                .json()
                                .then((json) => {
                                    self.setToken(json.token);
                                })
                                .then(() => 'OK');
                        } else if (r.status === 500) {
                            r.Error = 'Palvelinvirhe: Yritä myöhemmin uudelleen.';
                            return r.Error;
                        } else if (r.status === 403) {
                            r.Error = 'Käytetty URL ei ole kelvollinen.';
                            return r.Error;
                        } else return 'Salasanan antaminen epäonnistui.';
                    },
                    (r) => 'Palvelimeen ei saada yhteyttä. Tarkista internetyhteytesi tai yritä myöhemmin uudelleen.'
                )
                .finally(() => clearTimeout(timeoutId));
        },
        ForgotPassword: async (email) => {
            try {
                const response = await fetch(process.env.REACT_APP_API_URL_BASE + 'login/forgotPassword', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ email })
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'Failed to send password reset email.');
                }

                return 'OK'; // Indicate success
            } catch (error) {
                console.error('Error in ForgotPassword:', error.message);
                return error.message; // Return error message for display
            }
        }
    };
    return self;
})();
